import { Box } from "@mui/material";
import { UnstyledLink } from "Components/Routes/UnstyledLink";

import legioneMooneLogo from "Assets/Images/Images/legione-moone.svg";
import mooneLogo from "Assets/Images/Images/moone-logo.svg";
import { BetaChip } from "Components/Beta/BetaChip";
import { AccessRoleCodes, type AccessRoleCode } from "Models/AccessRoleCodes";
import { getIsBetaVisible } from "Utils/betaUtils";
import type { ReactNode } from "react";

const LogoWithBetaWrapper = ({ children }: { children: ReactNode }) => (
  <Box py={5} pl={3} display="flex" alignItems="center" gap={1.5}>
    {children}
  </Box>
);

const HunterLogo = (
  <Box
    component="img"
    src={legioneMooneLogo}
    alt="Legi.one Mo.one"
    minWidth="300px"
    maxWidth="400px"
    pt={2}
  />
);

type Props = {
  userType?: AccessRoleCode;
};

export const UnauthenticatedHeader = ({
  userType = AccessRoleCodes.Customer,
}: Props) => {
  const isHunter =
    userType === AccessRoleCodes.Hunter ||
    userType === AccessRoleCodes.HunterPlus;

  if (isHunter) {
    return <UnstyledLink to="https://mo.one">{HunterLogo}</UnstyledLink>;
  }

  return (
    <UnstyledLink to="https://mo.one">
      <LogoWithBetaWrapper>
        <img src={mooneLogo} alt="Mo.one" width="140" />
        {getIsBetaVisible() && <BetaChip />}
      </LogoWithBetaWrapper>
    </UnstyledLink>
  );
};
